"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockMirrorImpl__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "level",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eventTime",
                type: "uint256",
            },
        ],
        name: "TokenLevelUp",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eventTime",
                type: "uint256",
            },
        ],
        name: "TokenMinted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "from",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "to",
                type: "uint256",
            },
        ],
        name: "TokenPriceChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "initTokenPrice",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "string",
                name: "initBaseURI",
                type: "string",
            },
            {
                internalType: "string",
                name: "initMetadataHash",
                type: "string",
            },
            {
                internalType: "address",
                name: "initProxyRegistryAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "initSigner",
                type: "address",
            },
        ],
        name: "__Mirror_init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "receivers",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "quantities",
                type: "uint256[]",
            },
        ],
        name: "batchAirdrop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
        ],
        name: "buy",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "devAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "devShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "funderAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getUsedPreOrderQuota",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hostSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementationVersion",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "level",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "levelUp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "marketAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "marketShare",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "metadataHash",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "quantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "quota",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "preOrder",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistryAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "randomGeneratorAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newBaseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newMetaDataHash",
                type: "string",
            },
        ],
        name: "setMetadataHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "setRandomGenerator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_funderAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_devAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_marketAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_devShare",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_marketShare",
                type: "uint256",
            },
        ],
        name: "setShare",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newSigner",
                type: "address",
            },
        ],
        name: "setSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "newStageLock",
                type: "bool",
            },
        ],
        name: "setStageLock",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newPrice",
                type: "uint256",
            },
        ],
        name: "setTokenPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stageLock",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stockSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenInfo",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "usedPreOrderQuota",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class MockMirrorImpl__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockMirrorImpl__factory = MockMirrorImpl__factory;
MockMirrorImpl__factory.bytecode = _bytecode;
MockMirrorImpl__factory.abi = _abi;
//# sourceMappingURL=MockMirrorImpl__factory.js.map